import Cookies from 'js-cookie'
import qs from 'qs'
export default {
  data () {
    /* eslint-disable */
    return {
      // 设置属性
      mixinViewModuleOptions: {
        createdIsNeed: true,       // 此页面是否在创建时，调用查询数据列表接口？
        activatedIsNeed: false,    // 此页面是否在激活（进入）时，调用查询数据列表接口？
        getDataListURL: '',       // 数据列表接口，API地址
        getDataListIsPage: false, // 数据列表接口，是否需要分页？
        deleteURL: '',            // 删除接口，API地址
        deleteIsBatch: false,     // 删除接口，是否需要批量？
        deleteIsBatchKey: 'id',   // 删除接口，批量状态下由那个key进行标记操作？比如：pid，uid...
        exportURL: '',            // 导出接口，API地址
        isBodyPage:false         // 判断是否获取税源地列表
      },
      // 默认属性
      bodyPageList:[],            //税源地列表
      dataForm: {},               // 查询条件
      dataList: [],               // 数据列表
      order: '',                  // 排序，asc／desc
      orderField: '',             // 排序，字段
      page: 1,                    // 当前页码
      limit: 10,                  // 每页数
      total: 0,                   // 总条数
      dataListLoading: false,     // 数据列表，loading状态
      dataListSelections: [],     // 数据列表，多选项
      dataListSelectionid:[],
      addOrUpdateVisible: false  // 新增／更新，弹窗visible状态
    }
    /* eslint-enable */
  },
  created () {
    if(localStorage.getItem(this.$route.name)){
      this.dataForm =  JSON.parse(localStorage.getItem(this.$route.name))
    }
    if (this.mixinViewModuleOptions.createdIsNeed && this.mixinViewModuleOptions.getDataListURL) {
      this.$nextTick(() => {
        this.query()
      })
    }
    if(this.mixinViewModuleOptions.isBodyPage){
      this.getBodyPageList();
    }
  },
  activated () {
    // console.log('进入缓存')
    // this.query()

    if (this.mixinViewModuleOptions.activatedIsNeed) {
      this.query()
    }
  },
  deactivated(){
    console.log('离开缓存')

  },
  methods: {
    // 获取税源地列表
    async getBodyPageList(){
      const res = await this.$http.get('/sys/plat/body/page?page=1&limit=1000',{});
      if(res.data.code !== 0){
        return this.$message.error(res.msg)
      }else{
        this.bodyPageList = res.data.data.list
      }
    },
    // 获取数据列表
    query () {
      this.dataList = []
      this.dataListLoading = true
      this.$http.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
            ...this.dataForm
          }
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? res.data.list : res.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? res.data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 多选
    dataListSelectionChangeHandle (val) {
      this.dataListSelections = val
      this.dataListSelectionid = val.map((item) => {
        return item.id;
    })
    },
    // 排序
    dataListSortChangeHandle (data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.query()
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.query()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.query()
    },
    getDataList: function () {
      this.page = 1
	  let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'transparent'
	  })
	  setTimeout(() => {
        loading.close()
	  }, 500)
      this.query()
    },
    // 新增 / 修改
    addOrUpdateHandle (id,roleName) {
      localStorage.removeItem(this.$route.name)
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        if(roleName){
          this.$refs.addOrUpdate.dataForm.roleNameEdit = roleName
        }
        this.$refs.addOrUpdate.dataForm.id = id
        this.$refs.addOrUpdate.init()
      })
    },
    // 开户
    openHandle (rowData) {
	  this.openVisible = true
	  this.$nextTick(() => {
	    this.$refs.open.dataForm.id = rowData.id
	    this.$refs.open.dataForm.caId = rowData.caId
	    this.$refs.open.dataForm.payChannel = rowData.payChannel
        this.$refs.open.dataForm.bankName = rowData.payBankName ? rowData.payBankName : '' ;
        this.$refs.open.dataForm.platBody = rowData.bodyName ? rowData.bodyName : '' ;
	    this.$refs.open.init()
	  })
    },

    // 关闭当前窗口
    closeCurrentTab (data) {
      var tabName = this.$store.state.contentTabsActiveName
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 删除
    deleteHandle (id) {
      if (this.mixinViewModuleOptions.deleteIsBatch && !id && this.dataListSelections.length <= 0) {
        return this.$message({
          message: this.$t('prompt.deleteBatch'),
          type: 'warning',
          duration: 500
        })
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.delete(
          `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '/' + id}`,
          this.mixinViewModuleOptions.deleteIsBatch ? {
            'data': id ? [id] : this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
          } : {}
        ).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.query()
            }
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    postDeleteHandle (id) {
      if (this.mixinViewModuleOptions.deleteIsBatch && !id && this.dataListSelections.length <= 0) {
        return this.$message({
          message: this.$t('prompt.deleteBatch'),
          type: 'warning',
          duration: 500
        })
      }
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.post(
          `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '/' + id}`,
          this.mixinViewModuleOptions.deleteIsBatch ? {
            'data': id ? [id] : this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
          } : {}
        ).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.query()
            }
          })
        }).catch(() => {})
      }).catch(() => {})
    },
    // 导出
    exportHandle () {
      var params = qs.stringify({
        'access_token': Cookies.get('access_token'),
        ...this.dataForm,
        'ids':this.dataListSelectionid.toString(',')
      })
	      window.open(`${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`)
      // window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}/ids=${this.dataListSelectionid}`
    }
  }
}
